<div class="col" *ngIf="data!=null">
    <div class="table-responsive">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Descripción</th>
                    <th *ngFor="let col of columns"
                        [class.bg-info-subtle]="col.type === 'place-total' || col.type === 'grand-total'" [class.separator]="col.type === 'separator'">
                    {{ col.type === 'separator' ? '' : col.header }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let metric of metrics">

                    <!-- fila separadora -->
                    <ng-container *ngIf="metric.separator">
                    <td>&nbsp;</td>
                    <td *ngFor="let col of columns" class="separator">&nbsp;</td>
                    </ng-container>

                    <!-- fila normal -->
                    <ng-container *ngIf="!metric.separator">
                    <td class="fw-bold bg-secondary-subtle">
                        {{ metric.label }}
                    </td>

                    <td *ngFor="let col of columns"
                        class="text-end"
                        [class.fw-bold]="col.type === 'place-total' || col.type === 'grand-total'"
                        [class.separator]="col.type === 'separator'">

                        <ng-container *ngIf="getCellValue(metric, col) !== null">
                        {{ getCellValue(metric, col) | number:getFormat(metric) }}
                        </ng-container>

                    </td>
                    </ng-container>

                </tr>
            </tbody>
        </table>
    </div>
</div>